import { Component, Input } from '@angular/core';

@Component({
    selector: 'add-new-badge',
    templateUrl: './new-badge.component.html',
    styleUrls: ['./new-badge.component.scss'],
})
export class NewBadgeComponent {
    @Input() label: string = $localize`:@@NewBadge:NEW`;
}
